const social = {
  socialProfiles: [
    {
      name: "facebook",
      url: "https://www.facebook.com/ahmedemam755",
      icon: "fab fa-facebook-f",
    },
    {
      name: "linkedin",
      url: "https://www.linkedin.com/in/ahmedadelalemam755/",
      icon: "fab fa-linkedin-in",
    },
    {
      name: "drive",
      url: "https://docs.google.com/document/d/1vxUiLw9Ashe5AneMTA3-yt0XoOUhSK118uErLxfsW1U/edit?usp=sharing",
      icon: "https://img.icons8.com/windows/25/000000/google-drive.png",
    },
    {
      name: "github",
      url: "https://github.com/AhmedAdelAlemam",
      icon: "fab fa-github",
    },
    {
      name: "behance",
      url: "https://www.behance.net/ahmedemam755",
      icon: "fab fa-behance",
    },
    {
      name: "medium",
      url: "https://medium.com/@ahmedemam755",
      icon: "fab fa-medium-m",
    },
    {
      name: "overflow",
      url: "https://stackoverflow.com/users/8512281/ahmed-adel-alemam",
      icon: "fab fa-stack-overflow",
    },
  ],
};

export default social;
